import { useUserStore } from '@bv/stores';

import { useConversationsStore } from '@/stores/conversations/conversations.store';
import type { TypingType } from '@/types/events/typing';

export default function startTyping(data: TypingType): void {
  const conversationsStore = useConversationsStore();
  const detailsStore = useUserStore();

  if (detailsStore.userDetails!.id !== data.userData.identityServiceId) {
    conversationsStore.setTypingUser(data);
  }
}
